import React from 'react';
import ImageProductHosting from '../../media/product-hosting.png';
import * as Styles from './EmptyProducts.styles';

const HGImageProductHosting = () => {
  const alt = 'Hospedagem de Sites';

  return (
    <Styles.EmptyProductImage src={ImageProductHosting} aria-label={alt} />
  );
};

export default HGImageProductHosting;
